export const en = {
    showingResultsFor: 'Showing results for',
    noSearchResultHeading: 'We weren’t able to find any results',
    noSearchResultText: 'Please check the spelling or ',
    noSearchResultButtonText: 'try another search',
    filter: 'Filter',
    products: 'products',
    clearAll: 'Clear all',
    top: 'Top',
    displayingItems: 'Displaying items',
    outOf: 'out of',
    previous: 'Previous',
    next: 'Next',
    loading: 'Loading',
};

export const fr = {
    showingResultsFor: 'Showing results for',
    noSearchResultHeading: 'We weren’t able to find any results',
    noSearchResultText: 'Please check the spelling or',
    noSearchResultButtonText: 'try another search',
    filter: 'Filter',
    products: 'products',
    clearAll: 'Clear all',
    top: 'Top',
    displayingItems: 'Displaying items',
    outOf: 'out of',
    previous: 'Previous',
    next: 'Next',
    loading: 'Loading',
};
